import { Outlet } from "react-router-dom";

export default function MainWebBuilderLayout() {
  return <Outlet />;
}
